import { createContext } from 'react';

export const scrollAddContext = createContext<(pixels: number) => void>(() => {});
